export default function StateContainer({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <div className="mx-auto max-w-3xl space-y-5">
      <div className="w-full rounded-lg border border-gray-200 bg-white p-6 text-center md:p-8">
        {children}
      </div>
    </div>
  );
}
